import type { BidEntry } from '../data/mockLots';
import { BidderAvatar } from './BidderPill';

type Props = {
  entry: BidEntry;
  isLatest: boolean;
  count?: number;
  indexWidth?: number;
};

export function BidHistoryRow({ entry, isLatest, count, indexWidth = 4 }: Props) {
  const { bidder, price, bidIndex, extensionMs } = entry;
  const indexCh = `${Math.max(2, indexWidth + 1)}ch`;

  const inner = (
    <>
      <span
        className="font-mono text-[10px] tabular-nums text-fg-dim shrink-0 flex items-baseline gap-1.5 mr-3"
        title={
          extensionMs != null ? 'provably-fair timer extension for this bid' : 'extension pending'
        }
      >
        <span className="text-right" style={{ width: indexCh }}>
          {bidIndex != null ? `#${bidIndex}` : ''}
        </span>
        <span className="text-fg-dim/50">—</span>
        <span className="tabular-nums text-right" style={{ width: '3ch' }}>
          {extensionMs != null ? `${Math.round(extensionMs / 1000)}s` : '·'}
        </span>
      </span>
      <BidderAvatar bidder={bidder} size="xs" />
      <span className="font-medium text-[12px] text-fg truncate min-w-0 flex-1">
        {bidder.firstName}
        {bidder.username && (
          <span className="text-fg-dim font-mono text-[10px] ml-1">@{bidder.username}</span>
        )}
      </span>
      {typeof count === 'number' && (
        <span
          className={`font-mono text-[10px] tabular-nums px-1.5 py-[1px] border shrink-0 ${
            count >= 20
              ? 'text-accent border-accent/50 bg-accent/10'
              : count >= 10
                ? 'text-warning border-warning/40 bg-warning/5'
                : count >= 5
                  ? 'text-primary border-primary/40 bg-primary/5'
                  : count >= 2
                    ? 'text-success border-success/40 bg-success/5'
                    : 'text-fg-muted border-fg-dim/40 bg-fg-dim/5'
          }`}
        >
          ×{count}
        </span>
      )}
      <span className="font-mono text-[11px] tabular-nums text-fg shrink-0 w-14 text-right">
        ${price.toFixed(2)}
      </span>
    </>
  );

  const baseClass = `flex items-center gap-2 px-3 h-9 transition-colors duration-300 ${isLatest ? 'bg-primary/5 border-l-[3px] border-primary bid-row-enter' : 'border-l-[3px] border-transparent'}`;

  if (bidder.username) {
    return (
      <a
        href={`https://t.me/${bidder.username}`}
        target="_blank"
        rel="noreferrer"
        className={`${baseClass} hover:bg-bg-elev/60`}
      >
        {inner}
      </a>
    );
  }

  return (
    <div
      className={`${baseClass} cursor-default`}
      title="hidden username — say hi in @SkinStepChat"
    >
      {inner}
    </div>
  );
}
